import React from "react";
import "./Header.css";
function Header() {
  return (
    <div className="header-container">
      <a href="https://motorvia.co.za" target="_blank">
        <div className="header-logo" />
      </a>
      <div className="header-space"></div>
      {/* <div className="header-background"></div> */}
      <div className="header-title">Request a Quote</div>
    </div>
  );
}

export default Header;
